import Vue from 'vue'
import Vuex from 'vuex'
import home from '@/store/home';

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        user: null,

        loading: false, // 全局单个loading
        batchApiLoading: false,

        config: {}, //配置信息
    },

    mutations: {
        /**
         * 初始化用户信息
         * @param state
         * @param list
         * @returns {any}
         */
        initializeUserInformation: (state, user) => state.user = user,

        initializeSystemConfig: (state, data) => state.config = data,

        loading(state, val = true) {
            state.loading = val;
        },

        batchLoading(state, val = true) {
            state.batchApiLoading = val;
        }
    },

    actions: {
        async systemInitialize({ commit }) {
            commit('initializeSystemConfig', (await callApi("配置信息/获取")).data);

            const user = (await callApi("自己/信息获取")).data;

            commit('initializeUserInformation', user);
            commit('home/initializeAuthMenu', { auth: (await callApi("自己/权限获取")).data, user });
            commit('home/autoSelectMainuser');

            window.offFullscreenloading();
        }
    },
    modules: {
        home
    }
})

console.log('store js')

window.store = store;

export default store;